export const PROGRESS_PERCENT = 'PROGRESS_PERCENT';